<nav class="toolbar navbar navbar-light">
    <div *ngIf="listaDatosCaPeriodo && esPeriodoFinalizado" class="ms-1 nota-info">
        <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo finalizado</label>
    </div>    
</nav>

<div class="container-fluid container-fluid-list">
    <app-datosca-list *ngIf="searching" [listaDatosCaPeriodo]="listaDatosCaPeriodo" [esPeriodoFinalizado]="esPeriodoFinalizado" (editEmitter)="onEdit($event)"></app-datosca-list>
</div>
